<template>
	<div class="brick">
		<div class="list_top_box">
			<div class="left_option">
				<em class="lt_text">
					<span style="font-weight:bold;">{{ item.item_code }}</span>
				</em>
				<!-- <em class="lt_text">
					<span style="font-weight:bold;">{{ item.description }}</span>
				</em> -->
				<em class="lt_text">
					, Current Stock Quantity : <span style="font-weight:bold;">{{ item.on_hand | commaSeparated }}</span>
				</em>
			</div>
			<div class="left_option">
				<label for="in_stock_only_yn"><input type="checkbox" v-model="in_stock_only_yn" true-value="Y" false-value="N" @change="search()" />In Stock Only </label>
			</div>
		</div>

		<table class="list_tbl">
			<thead>
				<tr>
					<th width="110px;">Shipment No</th>
					<th width="120px;">Exp. Date</th>
					<th width="100px;">Cost</th>
					<th width="100px;">Initial Qty</th>
					<th width="100px;">On Hand</th>
					<th width="100px;">Adjust to</th>
					<th width="120px;">Location to</th>
					<th width="140px;">{{ isJC ? 'LOT#' : 'BIN' }}</th>
					<th width="120px;">QR Code</th>
					<th>Remark</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="lot in lots" v-bind:key="lot.lot_no">
					<td class="al_left">
						<a href="javascript:;" @click="gotoShipment(lot.sh_no)">{{ lot.sh_dn }}</a>
					</td>
					<td class="al_left"><CustomDatePicker v-model="lot.exp_date" /></td>
					<td class="al_right">{{ lot.cost | toCurrency }}</td>
					<td class="al_right">{{ lot.initial_quantity | commaSeparated }}</td>
					<td class="al_right">{{ lot.on_hand | commaSeparated }}</td>
					<td class="al_right">
						<currency-input type="text" v-model="lot.adjust_to" :precision="0" class="tbl_int ssm_int al_right" @focus="$event.target.select()" />
					</td>
					<td>
						<select v-model="lot.location_code" class="tbl_select">
							<option v-for="location in locations" v-bind:value="location.code" v-bind:key="location.code">{{ location.name }}</option>
						</select>
					</td>
					<td class="al_left">
						<input type="text" v-model.trim="lot.bin" class="tbl_int" @focus="$event.target.select()" />
					</td>
					<td class="al_left" style="vertical-align:middle;">
						<template v-if="lot.bin">
							<VueQrcode :value="item.item_code + '|' + lot.bin" :options="{ width: 33 }" style="margin-top:4px;margin-bottom:-4px;"></VueQrcode>
							<a href="javascript:void(0);" class="gray_bt2" style="margin-top:8px;" @click="printLabel(lot)">Print Label</a>
						</template>
					</td>
					<td class="al_left"><input type="text" v-model="lot.remark" class="tbl_int full_int" @focus="$event.target.select()" /></td>
				</tr>
			</tbody>
		</table>
		<div style="text-align:right;padding-right:10px;">Total Count : {{ list_count | commaSeparated }}</div>

		<Paging ref="paging" v-on:gotoPage="gotoPage"></Paging>

		<div class="bottom_bt_box">
			<ul>
				<!-- <li><router-link :to="{ name: 'shipmentDetail', params: { mode: 'add' }, query: { backUri: this.$route.fullPath } }">Add</router-link></li> -->
				<a v-if="modifiable" href="javascript:;" class="search_bt mgr_5" @click="submit(false)">Save & Return</a>
				<a v-if="modifiable" href="javascript:;" class="search_bt mgr_15" @click="submit(true)">Save Only</a>
				<a v-if="modifiable" href="javascript:;" class="gray_bt" @click="openModal('AddLot')">Add Inventory Lot</a>
			</ul>
		</div>

		<Modal @close="closeModal" v-if="showModal && modalName == 'AddLot'" :draggable="false">
			<template slot="title">Add Inventory Lot</template>
			<template slot="body">
				<!-- <div class="popup_body"> -->
				<div style="width:500px; height:350px;" v-on:keyup.esc="close()">
					<table class="view_tbl">
						<tbody>
							<tr>
								<th>Expiration Date</th>
								<td><CustomDatePicker v-model="new_lot.exp_date" /></td>
							</tr>
							<tr>
								<th>Cost</th>
								<td>
									<currency-input type="text" v-model="new_lot.cost" :precision="2" class="tbl_int ssm_int al_right" @focus="$event.target.select()" />
								</td>
							</tr>
							<tr>
								<th>Quantity</th>
								<td>
									<currency-input type="text" v-model="new_lot.initial_quantity" :precision="0" class="tbl_int ssm_int al_right" @focus="$event.target.select()" />
								</td>
							</tr>

							<tr>
								<th>{{ isJC ? 'LOT#' : 'BIN' }}</th>
								<td>
									<input type="text" v-model.trim="new_lot.bin" class="tbl_int" @focus="$event.target.select()" />
								</td>
							</tr>
							<tr>
								<th>Remark</th>
								<td>
									<input type="text" v-model.trim="new_lot.remark" class="tbl_int" @focus="$event.target.select()" />
								</td>
							</tr>
						</tbody>
					</table>
					<div class="popup_bottom">
						<a href="javascript:;" @click="addLot()" class="search_bt">Save & Close</a>
						<a href="javascript:;" @click="closeModal()" class="gray_bt">Cancel</a>
					</div>
				</div>
			</template>
		</Modal>

		<Modal @close="closeModal" v-if="showModal && modalName == 'SelectBarcode'" :draggable="false">
			<template slot="title">Select Barcode</template>
			<template slot="body">
				<div style="width:230px; height:100px;" v-on:keyup.esc="close()">
					<div>
						<select v-model="lot_to_print.unit" class="tbl_select mm_int">
							<option v-for="barcode in barcodes" v-bind:value="barcode.unit" v-bind:key="barcode.unit">{{ barcode.unit }} - {{ barcode.bc }}</option>
						</select>
					</div>
					<div class="popup_bottom">
						<a href="javascript:;" @click="printSelectedUnit()" class="search_bt">Print</a>
						<a href="javascript:;" @click="closeModal()" class="gray_bt">Cancel</a>
					</div>
				</div>
			</template>
		</Modal>
	</div>
</template>

<script>
//import { today, daysAgo } from '@/utils/date';
import { apiGetReportTemplate, reportMrtUrl, Report } from '@/api/util';
import Paging from '@/components/common/Paging';
import CustomDatePicker from '@/components/common/CustomDatePicker.vue';
import { inputSelectOnClick } from '@/utils/etc.js';
import { apiIndex, apiSelectItem } from '@/api/item/master.js';
import { apiSelectLotList, apiAdjustInventory, apiAddLot } from '@/api/item/inventory.js';
import Modal from '@/components/common/Modal';
import _ from 'lodash';
import VueQrcode from '@chenfengyuan/vue-qrcode';

export default {
	data: function() {
		return {
			uri: null,
			backUri: '/',
			paging_yn: 'Y',
			page_size: 25,
			page_no: 1,
			list_count: 0,

			in_stock_only_yn: 'N',
			item: {},

			oldLots: [],
			lots: [],
			changed: [],
			new_lot: {},

			locations: [],

			modalName: '',
			showModal: false,

			lot_to_print: {},
		};
	},
	computed: {
		modifiable() {
			var menus = this.$session.get('menus');
			for (var i = 0; i < menus.length; i++) {
				// if (menus[i].path == this.$router.history.current.path && menus[i].modify_yn == 'Y') return true;
				if ((menus[i].path == this.$router.history.current.path || menus[i].path == this.$router.history.current.path.replace('add', 'detail')) && menus[i].modify_yn == 'Y') return true;
			}
			return false;
		},
		barcodes() {
			var barcodes = [];

			if (this.item.barcode) barcodes.push({ unit: 'PC', bc: this.item.barcode });
			if (this.item.barcode_box) barcodes.push({ unit: 'BX', bc: this.item.barcode_box });
			if (this.item.barcode_case) barcodes.push({ unit: 'CS', bc: this.item.barcode_case });

			return barcodes;
		},
		isJC() {
			return this.$session.get('user').company_id == 'jc' ? true : false;
		},
	},
	watch: {
		lots: {
			handler: function(after) {
				// Return the object that changed
				var vm = this;
				this.changed = after.filter(function(p, idx) {
					return Object.keys(p).some(function(prop) {
						if (vm.$data.oldLots[idx][prop] != null) return p[prop] !== vm.$data.oldLots[idx][prop];
						else return p[prop] ? true : false;
					});
				});
				//console.log(this.changed);
			},
			deep: true,
		},
	},
	components: {
		CustomDatePicker,
		Paging,
		Modal,
		VueQrcode,
	},
	methods: {
		async printSelectedUnit() {
			if (!this.lot_to_print.unit) {
				this.$toast.error('Select unit to print');
				return;
			}
			this.closeModal();

			await this.printLabelConfirm();
		},
		async printLabel(lot) {
			//lot.qr_code = lot.item_code + '|' + lot.bin;
			//console.log(lot);
			//alert('Under Development');

			if (!lot.bin) {
				this.$toast.error('Empty BIN');
				return;
			}

			//console.log(this.barcodes);

			this.lot_to_print = lot;
			this.lot_to_print.unit = 'PC';

			if (this.barcodes.length == 1) {
				this.lot_to_print.unit = this.barcodes[0].unit;
				await this.printLabelConfirm();
			} else if (this.barcodes.length > 1) {
				this.openModal('SelectBarcode');
			} else {
				await this.printLabelConfirm();
			}
		},
		async printLabelConfirm() {
			11;
			this.lot_to_print.qr_code = this.lot_to_print.item_code + '|' + this.lot_to_print.unit + '|' + this.lot_to_print.bin;
			const reportTemplate = await apiGetReportTemplate('LotLabel', reportMrtUrl('LotLabel'));
			const report = new Report(reportTemplate, this.lot_to_print, 'LotLabel');
			this.$store.commit('setReport', report);
		},
		openModal(modalName) {
			if (modalName == 'AddLot') this.new_lot = {};

			this.modalName = modalName;
			this.showModal = true;
		},
		closeModal() {
			this.showModal = false;
		},
		async addLot() {
			if (!this.new_lot.initial_quantity || !this.new_lot.cost) {
				this.$toast.error('Empty cost or quantity');
				return false;
			}

			this.new_lot.item_id = this.item.item_id;
			this.new_lot.on_hand = this.new_lot.initial_quantity;

			//console.log(param);
			const { data } = await apiAddLot(this.new_lot);

			if (data.result) {
				this.$toast.success('Saved successfully');
				this.search();
			} else {
				this.$toast.error(data.msg);
			}
			this.showModal = false;
		},
		gotoShipment(sh_no) {
			this.$router.push({
				name: 'shipmentDetail',
				params: { mode: 'detail' },
				query: { backUri: this.uri, sh_no: sh_no },
			});
		},
		gotoPage(pageNo) {
			this.page_no = pageNo;
			this.selectLots(pageNo);
		},
		async submit(stay) {
			//console.log(this.changed);
			if (this.changed.length == 0) {
				this.$toast.error('Nothing to save');
				return false;
			}

			this.changed.forEach(function(item) {
				if (!item.adjust_to) item.adjust_to = 0;
			});

			var adjust_sum = 0;
			this.lots.forEach(l => {
				if (l.adjust_to != null) adjust_sum += l.adjust_to;
			});

			var param = {
				item_id: this.item.item_id,
				adjust_reason: 'adjust',
				adjust_to_list: this.changed,
			};

			if (this.item.on_hand != adjust_sum) param.quantity_changed = true;

			//console.log(this.item.on_hand, adjust_sum, param);
			const { data } = await apiAdjustInventory(param);

			if (data.result) {
				this.$toast.success('Saved successfully');
				if (!stay) this.$router.push(this.backUri);
				else this.selectLots();
			} else {
				this.$toast.error(data.msg);
			}
		},
		search() {
			this.selectLots();
		},
		async selectLots(pageNo) {
			if (pageNo) this.page_no = pageNo;
			else this.page_no = 1;

			if (!this.selectItem()) return;

			const { data } = await apiSelectLotList({
				paging_yn: this.paging_yn,
				page_size: this.page_size,
				page_no: this.page_no,
				start_index: this.page_size * (this.page_no - 1),

				item_id: this.item.item_id,
				in_stock_only_yn: this.in_stock_only_yn,
			});

			//console.log(data);

			this.lots = data.lotList;
			//console.log(this.lots);
			this.oldLots = _.cloneDeep(this.lots);
			//console.log(this.histories);
			this.list_count = data.list_count;

			this.$refs.paging.setPage(this.page_no, this.page_size, this.list_count);

			var uri = '/item/inventory_detail?item_id=' + this.item.item_id;
			uri += '&backUri=' + this.backUri;
			uri += '&in_stock_only_yn=' + this.in_stock_only_yn;
			/////this.$router.replace(uri).catch(err => err);
			this.uri = uri;
			//window.history.pushState({}, null, uri);

			inputSelectOnClick();
		},
		async selectItem() {
			const { data } = await apiSelectItem({
				item_id: this.item.item_id,
			});
			//console.log(data);
			if (data.item) {
				this.item = data.item;
				return true;
			}

			this.$toast.error('Item Not Found');
			return false;
		},
		async index() {
			const { data } = await apiIndex();

			this.locations = data.locationList;
		},
		async init() {
			await this.index();
			if (this.$route.query.item_id) this.item.item_id = this.$route.query.item_id;

			if (this.item.item_id) await this.selectLots(this.$route.query.page_no);
		},
	},
	created() {
		if (this.$route.query.backUri) this.backUri = this.$route.query.backUri;

		this.$store.commit('setSideIndex', 1);
		this.$store.commit('setSelectedMenu', 'nav_li_inventory_detail');
		this.$store.commit('setSubTitle', 'Item -> Inventory Detail');

		this.init();
	},
	mounted() {
		inputSelectOnClick();
	},
};
</script>

<style></style>
